import React from 'react';

/** One habit-day cell in a week or month grid. */
export function HabitCell({
  value = 0, goal = 1, counted = false, today = false, height = 44, onClick, style
}) {
  const hit = value >= goal && value > 0;
  return (
    <div onClick={onClick} style={{
      height, display: 'flex', alignItems: 'center', justifyContent: 'center',
      borderTop: '1px solid var(--bujo-rule-hairline)',
      background: today ? 'color-mix(in srgb, var(--bujo-accent) 14%, transparent)'
        : hit ? 'color-mix(in srgb, var(--bujo-label) 10%, transparent)' : 'transparent',
      boxShadow: today ? 'inset 0 0 0 1px var(--bujo-accent)' : 'none',
      font: `var(--bujo-fw-regular) ${counted && value > 0 ? 'var(--bujo-fs-meta)' : '14px'}/var(--bujo-lh-tight) var(--bujo-font-mono)`,
      color: today ? 'var(--bujo-accent)'
        : hit ? 'var(--bujo-label)'
        : value > 0 ? 'var(--bujo-text-primary)' : 'var(--bujo-text-meta)',
      cursor: onClick ? 'pointer' : 'default', ...style
    }}>
      {counted && value > 0 ? value : hit ? 'x' : '\u00b7'}
    </div>
  );
}
